<template>
    <b-modal
        :id="modalId"
        ref="modalDeleteWriteOff"
        title-tag="h2"
        title="Delete write off"
        lazy
    >
        <div v-if="warningMessagePayment">
            <div class="alert-wrapper">
                <div class="alert alert-warning alert-dismissible" role="alert">
                    {{ warningMessagePayment }}
                </div>
            </div>
        </div>

        <p v-if="writeOff">
            Are you sure you want to delete write off for
            {{ writeOff.invoice.name }} ?
        </p>

        <template v-slot:modal-footer>
            <modal-footer
                :is-loading="isLoading"
                :isDisabled="isHasUsersChooseInvoice"
                ok-title="Proceed"
                @ok-action="proceedDelete"
                @cancel-action="close"
            />
        </template>
    </b-modal>
</template>
<script type="text/javascript">
import BillingWriteOffServices from "@/services/billing/billing-writeoff";

export default {
    components: {
        ModalFooter: () => import("@/components/elements/modal-footer")
    },
    props: {
        modalId: {
            type: String,
            required: true
        },
        writeOff: {
            type: Object,
            default: null
        }
    },
    computed: {
        isHasUsersChooseInvoice() {
            return this.warningMessagePayment !== "";
        },
        warningMessagePayment() {
            return this.writeOff && this.writeOff.invoice_id
                ? this.$store.getters["billing/warningMessagePayment"](
                      this.writeOff.invoice_id
                  )
                : "";
        }
    },
    data() {
        return {
            isLoading: false
        };
    },
    methods: {
        proceedDelete() {
            this.isLoading = true;

            BillingWriteOffServices.writeOffInvoiceRemove(this.writeOff.id)
                .then(response => {
                    if (response.code == 200) {
                        this._message(response.messages);
                        this.$emit("reload");
                    } else {
                        this._message(response.messages, "danger");
                    }

                    this.close();
                })
                .catch(error => {
                    this._message(
                        "Error : Unable to delete write off",
                        "danger"
                    );
                    this.close();
                    console.error(error);
                });
        },
        close() {
            this.isLoading = false;
            this.$refs.modalDeleteWriteOff.hide();
        }
    }
};
</script>
